// extracted by mini-css-extract-plugin
module.exports = {"mainBar":"BottomTabs_mainBar__20l1x","displayArea":"BottomTabs_displayArea__kKENY"};